import FormFieldValidation from "../../../enums/FormFieldValidation";

export enum AuthenticateFormFieldValidation {
    
    /**
     * @description The field is an email address and not a supported domain
     */
    UNSUPPORTED_EMAIL_DOMAIN = 'UNSUPPORTED_EMAIL_DOMAIN',
}

export interface ILoginValidation {
    displayName: FormFieldValidation;
    emailAddress: FormFieldValidation | AuthenticateFormFieldValidation;
    otp: FormFieldValidation;
}

const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const invalidEmailDomains = [
    "fm-24.com",
    "fm24systems.com",
    "macro-group.com",
    "consultdolphin.com"
]

const validate = (name: string, email: string, showOtp: boolean, otp?: string): ILoginValidation => {
    const emailDomain = email.split('@')[1];

    const emailValidation = isValidEmail(email)
        ? !invalidEmailDomains.includes(emailDomain)
            ? FormFieldValidation.VALID
            : AuthenticateFormFieldValidation.UNSUPPORTED_EMAIL_DOMAIN
        : FormFieldValidation.INVALID_EMAIL;
    
    const nameValidation = name.length > 0
        ? FormFieldValidation.VALID
        : FormFieldValidation.INVALID;

    const otpValidation = showOtp
        ? otp?.length === 6
            ? FormFieldValidation.VALID
            : FormFieldValidation.INVALID
        : FormFieldValidation.VALID;

    return {
        displayName: nameValidation,
        emailAddress: emailValidation,
        otp: otpValidation
    };
}

const newValidation = (): ILoginValidation => ({
    displayName: FormFieldValidation.VALID,
    emailAddress: FormFieldValidation.VALID,
    otp: FormFieldValidation.VALID
});

export { validate, newValidation };